import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminAnalyticsService } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindAdminAnalytics } from './interface';

export const findAdminAnalytics = createAsyncThunk(
  'adminAnalytics/findAdminAnalytics',
  async (values: FindAdminAnalytics, { rejectWithValue }) => {
    try {
      const response = await AdminAnalyticsService.find({ query: values });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
